/** MIME Excel .xlsx (совпадает с server EXCEL_REPORT_MIME_TYPE). */
export const AGENT_CHAT_XLSX_MIME =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const AGENT_CHAT_FILE_ACCEPT =
  'image/jpeg,image/png,image/gif,image/webp,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export function isAgentChatAttachableFile(file: File): boolean {
  if (file.type.startsWith('image/')) {
    return /image\/(jpeg|jpg|png|gif|webp)/i.test(file.type);
  }
  const name = file.name.toLowerCase();
  if (!name.endsWith('.xlsx')) return false;
  return (
    !file.type ||
    file.type === 'application/octet-stream' ||
    file.type === AGENT_CHAT_XLSX_MIME
  );
}
